window.onRecaptchaSuccess = function (token) {
    var captcha =  document.querySelector(".g-recaptcha");
    const div = captcha.closest(".form-control, .re-captcha-wrap");
    const errorDiv = div?.querySelector(".error-message");
    if (errorDiv) errorDiv.textContent = "";
    div?.classList.remove("error-outer");

  };

/*async function fetchAllProductsByType(productType) {
  let allProducts = [];
  let hasNextPage = true;
  let endCursor = null;

  while (hasNextPage) {
    const query = `
      {
        products(first: 250, query: "product_type:${productType}"${endCursor ? `, after: "${endCursor}"` : ''}) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              title
              id
            }
          }
        }
      }
    `;

    const response = await fetch('https://your-store.myshopify.com/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'your-storefront-access-token'
      },
      body: JSON.stringify({ query })
    });

    const json = await response.json();
    const productsChunk = json.data.products.edges;
    allProducts.push(...productsChunk.map(edge => edge.node));

    hasNextPage = json.data.products.pageInfo.hasNextPage;
    endCursor = productsChunk.length ? productsChunk[productsChunk.length - 1].cursor : null;
  }

  return allProducts;
}*/

document.addEventListener("DOMContentLoaded", function () {

    const thankYouSection = document.getElementById("success-section");
    thankYouSection.style.display = "none";
  
    var captcha =  document.querySelector(".g-recaptcha");
  
  /* Disable/Enable the product kind dropdown logic */
  const productType = document.getElementById("product-type-dropdown");
  const productKind = document.getElementById("product-kind-dropdown");
  const labelText = productKind.dataset.label;
  const placeholderText = productKind.dataset.placeholder;
  productKind.innerHTML = `
        <option value="" hidden>${labelText}</option>
        <option value="">${placeholderText}</option>
      `;

  let productKindTouched = false; // track user interaction


  const productOptionsMap = {
    'Con_Headphones': [
        'ACCENTUM Open',
        'ACCENTUM Plus Wireless',
        'ACCENTUM True Wireless',
        'ACCENTUM Wireless',
        'ACCENTUM Wireless SE',
        'BT T100 블루투스® 오디오 트랜스미터',
        'BTD 600',
        'BTD 700 Bluetooth® USB 동글',
        'CX 100',
        'CX 150BT',
        'CX 300S',
        'CX 350BT',
        'CX 400BT True Wireless',
        'CX 6 Travel',
        'CX 80S',
        'CX Plus SE True Wireless',
        'CX SPORT',
        'Custom Comfort Tips',
        'HD 100',
        'HD 250BT',
        'HD 300',
        'HD 350BT',
        'HD 400S',
        'HD 450BT',
        'HD 450SE',
        'HD 458BT',
        'HD 518',
        'HD 559',
        'HD 560S',
        'HD 569',
        'HD 579',
        'HD 598 CS',
        'HD 599',
        'HD 599 SE',
        'HD 600',
        'HD 620S',
        'HD 650',
        'HD 660S2',
        'HD 800 S',
        'HD 820',
        'IE 200',
        'IE 60',
        'IE 600',
        'IE 900',
        'MOMENTUM 3 Wireless',
        'MOMENTUM 4 Copper',
        'MOMENTUM 4 Denim',
        'MOMENTUM 4 Wireless',
        'MOMENTUM 4 Wireless Pride Edition',
        'MOMENTUM 4 Wireless – Dragon Edition',
        'MOMENTUM Free',
        'MOMENTUM Free SE',
        'MOMENTUM In-Ear',
        'MOMENTUM Sport',
        'MOMENTUM True Wireless 2',
        'MOMENTUM True Wireless 3 - 3세대',
        'MOMENTUM True Wireless 4 - 4세대',
        'PXC 550-II Wireless',
        'SPORT True Wireless',
        '젠하이저 CX Plus 트루 와이어리스',
        '젠하이저 CX 트루 와이어리스',
        'Other Products'
      ],
    'Con_Audiophiles_Headphones': [
        'Custom Comfort Tips',
        'HD 505 Copper',
        'HD 505 Gold',
        'HD 550',
        'HD 559',
        'HD 560S',
        'HD 569',
        'HD 579',
        'HD 598 CS',
        'HD 599',
        'HD 599 SE',
        'HD 600',
        'HD 620S',
        'HD 650',
        'HD 660S',
        'HD 660S2',
        'HD 800 S',
        'HD 820',
        'HDV 820',
        'HDVA 600',
        'IE 200',
        'IE 300',
        'IE 600',
        'IE 80 S BT',
        'IE 800 S',
        'IE 900',
        '젠하이저 HE 1',
        'Other Products'
      ],
    'Con_Soundbars': [
      '-AMBEO- Soundbar | Plus',
      '-AMBEO- Soundbar | 미니',
      '-AMBEO- Sub',
      '-AMBEO- 사운드바 | Max',
      'Other Products'
    ],
    'Con_Hearing': [
      'BT T100 블루투스® 오디오 트랜스미터',
      'Conversation Clear Plus',
      'Flex 5000',
      'HD 35 TV',
      'HD 518',
      'HD 65 TV',
      'RS 120 II',
      'RS 120-W',
      'RS 175-U',
      'RS 195',
      'RS 2000',
      'RS 5000',
      'RS 5200',
      'Set 860',
      'Set 880',
      'SoundProtex',
      'SoundProtex Plus',
      'TV Clear Set',
      'TV Clear Set 2',
      'Other Products'
    ]
  };
  
  // function updateProductKindOptions(selectedType) {
  //   const kinds = productOptionsMap[selectedType] || [];
  //   productKind.innerHTML = `
  //     <option value="" hidden>${labelText}</option>
  //     <option value="">${placeholderText}</option>
  //   ` + kinds.map(kind => `<option value="${kind}">${kind}</option>`).join('');
  // }

  function updateProductKindOptions(selectedType, products) {
    productKind.innerHTML = `
      <option value="" hidden>${labelText}</option>
      <option value="">${placeholderText}</option>
    `;

    products.forEach(product => {
      const option = document.createElement("option");
      option.value = product.value;
      option.textContent = product.title;
      productKind.appendChild(option);
    });
  }

  
  if (productType && productKind) {
  productKind.disabled = true;

  productType.addEventListener("change",async  () => {
    const selectedType = productType.value;
   const productList = await fetchAllProductsByType(selectedType);

    
    if (selectedType !== "") {
      console.log(shopifyCategoryData);

    const selectedCategory = shopifyCategoryData.find(cat => cat.category_name === selectedType);

    if (selectedCategory && selectedCategory.products.length > 0) {
      // Pass only the products of the selected category
      updateProductKindOptions(selectedType, selectedCategory.products);
      productKind.disabled = false;
    } else {
      // No products found for this category
      //productKind.disabled = true;
      productKind.value = "";
      clearError(productKind);
      productKind.innerHTML = `
        <option value="" hidden>${labelText}</option>
        <option value="">${placeholderText}</option>
      `;
    }

      //updateProductKindOptions(selectedType, productList);
      //productKind.disabled = false;
    } else {
      productKind.disabled = true;
      productKind.value = "";
      clearError(productKind);
      productKindTouched = false;
      productKind.innerHTML = `
        <option value="" hidden>${labelText}</option>
        <option value="">${placeholderText}</option>
      `;
    }
  });

  productKind.addEventListener("change", () => {
    productKindTouched = true;
    if (!productKind.value) {
      showError(productKind, "This field cannot be empty");
    } else {
      clearError(productKind);
    }
  });
}
async function fetchAllProductsByType(handle) {
  try {
    const response = await fetch(`/collections/${handle}/products.json?limit=250`);
    if (!response.ok) throw new Error("Network response was not ok");
    const data = await response.json();
    return data.products || [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

  /* Form validation logic */
 // console.log("In form js");
  const form = document.getElementById("support-form");
  const fields = {
    name: form.querySelector("input[name='firstname']"),
    castle: form.querySelector("input[name='lastname']"),
    email: form.querySelector("input[name='email']"),
    message: form.querySelector("textarea[name='message']")
  };

  const validators = {
    name: val => val.length >= 1,
    castle: val => val !== "",
    email: val => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
    message: val => val !== ""
  };

  const messages = {
    name: ["This field cannot be empty", "Name must be at least 1 characters."],
    castle: ["This field cannot be empty"],
    email: ["This field cannot be empty", "Email is not valid."],
    message: ["This field cannot be empty"]
  };

  Object.entries(fields).forEach(([key, field]) => {
    field.addEventListener("input", () => {
      const val = field.value.trim();
      if (!val) {
        showError(field, messages[key][0]); // show required error
      } else if (!validators[key](val)) {
        showError(field, messages[key][1] || messages[key][0]); // show invalid error
      } else {
        clearError(field); // valid input
      }

      //if (val && validators[key](val)) clearError(field);
    });
  });

//const language =  Weglot.getCurrentLang();
  const dropdowns = form.querySelectorAll("select.required-dropdown");
  const consentCheckbox = document.querySelector(".required-checkbox");
    const consentWrapper = consentCheckbox.closest('.custom-field');
  const errorClass = 'error-highlight';

  dropdowns.forEach(dropdown => {
    dropdown.addEventListener("change", () => {
      const val = dropdown.value;
      if (!val) {
        showError(dropdown, "This field cannot be empty");
      } else {
        clearError(dropdown);
      }
    });
  });

    consentCheckbox.addEventListener('change', function () {
      if (consentCheckbox.checked) {
        consentWrapper.classList.remove(errorClass);
      }else{
        consentWrapper.classList.add(errorClass);
      }
    });
 
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    e.stopPropagation();
    let valid = true;
    Object.entries(fields).forEach(([key, field]) => {
      const val = field.value.trim();
      clearError(field);
      if (!val) {
        showError(field, messages[key][0]);
        valid = false;
      } else if (!validators[key](val)) {
        showError(field, messages[key][1] || messages[key][0]);
        valid = false;
      }
    });

      // Validate consent checkbox
      if (!consentCheckbox.checked) {
        
        consentWrapper.classList.add(errorClass);
        valid = false;
      } else {
        consentWrapper.classList.remove(errorClass);
      }

      // Validate reCAPTCHA
     const recaptchaResponse = grecaptcha.getResponse();
      if (recaptchaResponse.length === 0) {
        //recaptcha.classList.add(errorClass);
        showError(captcha, "This field cannot be empty");
        valid = false;
      } else {
              clearError(captcha);
        //recaptcha.classList.remove(errorClass);
      }

    dropdowns.forEach(dropdown => {
      const val = dropdown.value;
      clearError(dropdown);

    // if (dropdown.disabled) return;
      
      if (!val) {
        showError(dropdown, "This field cannot be empty");
        valid = false;
      }
    });

    if (!valid){
      e.preventDefault();
      const firstError = form.querySelector(".error-message:not(:empty)");
      if (firstError) {
        const scrollToTarget = firstError.closest(".form-control, .select-wrapper");
        scrollToTarget?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }else{
      // const language =  Weglot.getCurrentLang();

      // console.log(language);
        const payload = {
          //url: form.elements["url"].value,
          language: form.elements["language"].value,
          request_type: form.elements["request_type"].value,
          request: form.elements["request"]?.value || "Spare_parts",
          keyword: form.elements["keyword"]?.value || "Con_Audiophiles_Headphones",
          product_name: form.elements["product_name"]?.value || "HD 800 S",
          order_no: form.elements["order_no"]?.value || "",
          country: form.elements["country"]?.value || "CC",
          firstname: form.elements["firstname"].value,
          lastname: form.elements["lastname"].value,
          email: form.elements["email"].value,
          street: form.elements["street"]?.value || "",
          zip_code: form.elements["zip_code"]?.value || "",
          city: form.elements["city"]?.value || "",
          phone: form.elements["phone"]?.value || "",
          message: form.elements["message"].value
          //terms: form.elements["terms"]?.checked ? "terms" : "",
          //"g-recaptcha-response": grecaptcha.getResponse()
        };

      console.log(payload);
      
      try {
        const response = await fetch('https://www.sennheiser-hearing.com/.netlify/functions/sendSupportRequest', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
  
        if (response) {
        
          if(response.value == "success"){
          
            console.log(response);
           
          }
        
          form.style.display = "none";
          thankYouSection.style.display = "block";
        } else {
          alert("There was an issue submitting your request. Please try again.");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong. Please try again later.");
      }
    }
    

  });
  
  function showError(field, msg) {
    const div = field.closest(".form-control, .re-captcha-wrap")
      const errorDiv = div.querySelector(".error-message");
    if (errorDiv) errorDiv.textContent = msg;
    div?.classList.add("error-outer");
  }

  function clearError(field) {
    const div = field.closest(".form-control, .re-captcha-wrap");
    const errorDiv = div?.querySelector(".error-message");
    if (errorDiv) errorDiv.textContent = "";
    div?.classList.remove("error-outer");
  }

});



